//MyFiles
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet, faAdd, faArrowLeft, faShareAlt, faPingPongPaddleBall } from '@fortawesome/free-solid-svg-icons';
// import walletimage from '../../assets/pageimages/walletimage.webp';
import UploadImage from '../../components/UploadImage';

function MyFiles() {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black py-4">
      
      <div className="min-h-[80vh] lg:min-h-[92vh] px-2 mx-auto">
        <div className="flex justify-start mb-2 border-b border-blue-400">
            <h2 className="text-xl lg:text-2xl font-bold text-yellow-200 text-center mb-4 px-4">📤 File Uploader</h2>
        </div>
        <div className="bg-gray-800 p-4 rounded-lg shadow-md mb-8">
            <UploadImage />
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-gray-400 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-sm">© 2025 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
}

export default MyFiles;
